export enum MetaPixelName {
  Hiring = 'Hiring',
  ReachPurchase = 'ReachPurchase',
}

export enum MetaPixelEvent {
  PageView = 'PageView',
  Lead = 'Lead',
  CompleteRegistration = 'CompleteRegistration',
  Contact = 'Contact',
  SubmitApplication = 'SubmitApplication',
  ViewContent = 'ViewContent',
  Search = 'Search',
}
